import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppShell, Button, Center, Container, Group, Loader } from '@mantine/core';
import { signOut } from '@/queries/auth/authActions';
import { meKeys } from '@/queries/me/keys';
import { fetchMe, useMe } from '@/queries/me/useMe';

export const OnboardingAppLayout = () => {
  const queryClient = useQueryClient();
  const { data: me } = useMe({ enabled: false });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    async function fetch() {
      setIsFetching(true);
      try {
        const data = await queryClient.fetchQuery({
          queryKey: meKeys.all,
          queryFn: () => fetchMe(queryClient),
        });
        if (!data?.user) {
          navigate('/auth/login');
        }
      } finally {
        setIsFetching(false);
      }
    }
    fetch();
  }, [queryClient, navigate]);

  if (isFetching) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (!me?.user) {
    return null;
  }

  return (
    <AppShell header={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Group justify="flex-end" align="center" h="100%" px="md">
          <Button onClick={() => signOut()}>{t('navbar.logout')}</Button>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <Container>
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
};
